import React, { PureComponent } from 'react';
import { Icon } from 'react-fa';
import Modal from '../../components/Render/Modal/Modal';
import ImageUploader from '../../components/ImageUploader';
import { IMAGES_REPO } from '../../config';

class Image extends PureComponent {

  state = { isOpen: false };

  removeHandler() {
    const { input: { onChange } } = this.props;
    onChange("");
  }

  chooseHandler(imageUrl) {
    const { input: { onChange } } = this.props;
    onChange(imageUrl);
  }

  toggleOpenModal() {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    const { input: { value }, meta: { touched, error }, label } = this.props;

    return (
      <div>
        {label && <label>{label}</label>}
        <div className="planet-image">
          {value ? <img className="planet-image__img" src={IMAGES_REPO + '' + value}/> :
            <div className="planet-image__empty-image">
              <Icon name="picture-o"/>
              <div className="planet-image__empty-image-info">
                <label>Max size: 5mb</label>
              </div>
            </div>}
          <div className="planet-image__choose">
            <button type="button" className="btn btn-primary" onClick={this.toggleOpenModal.bind(this)}>Choose</button>
            {value &&
            <button onClick={this.removeHandler.bind(this)} className="btn btn-sm btn-primary btn-remove btn-circle">
              <Icon
                name="remove"/></button>}
          </div>
          <Modal
            isOpen={this.state.isOpen}>
            <ImageUploader select={this.chooseHandler.bind(this)} cancel={this.toggleOpenModal.bind(this)}/>
          </Modal>
          <div className="form__errors">
            {touched && error && <span>{error}</span>}
          </div>
        </div>
      </div>
    );
  }
}

Image.propTypes = {};
Image.defaultProps = {};

export default Image;



// WEBPACK FOOTER //
// ./src/components/image/Image.js